module.exports = __webpack_public_path__ + "static/WheatBranMicronized-fd754cff52768bfa01b9354f783a2551.webp";